import React, { useState } from 'react';
import { Routes, Route } from 'react-router-dom';

import LayoutDashboard from './layouts/LayoutDashboard.jsx';
import Home        from './pages/Home.jsx';
import Dashboard   from './pages/Dashboard.jsx';
import Quotation   from './pages/Quotation.jsx';
import Orderform   from './pages/Orderform.jsx';
import User        from './pages/User.jsx';
import NotFound    from './pages/NotFound.jsx';

const App = () => {
  const [pageParams, setPageParams] = useState({});
  return (
    <Routes>
      <Route exact path="/" element={<Home />} />
      <Route path="/" element={<LayoutDashboard pageParams={pageParams} />}>
        <Route path="/dashboard"           element={<Dashboard setPageParams={setPageParams} />} />
        <Route path="/quotation"           element={<Quotation setPageParams={setPageParams} />} />
        <Route path="/quotation/:id"       element={<Orderform setPageParams={setPageParams} />} />
        <Route path="/orderform"           element={<Orderform setPageParams={setPageParams} />} />
        <Route path="/user"                element={<User setPageParams={setPageParams} />} />
      </Route>
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default App;
